module.exports = __webpack_public_path__ + "static/media/support-team.b9c47d28.svg";